import LayoutMaster from "components/layout/layout_master";
import get_udiamond_all, {
  GetUdiamondAllResponse,
} from "lib/worker/api/get_udiamond_all";
import { useEffect, useState } from "react";
import UDiamondModal from "components/modal/udiamond_modal";
import { AppReducerStateProps } from "lib/store";
import { connect } from "react-redux";
import { GetServerSideProps } from "next";
import {
  CheckWithPrefix,
  CheckWithPrefixResponse,
} from "lib/infomation_vender/document";

interface ExchangePageProps {
  state: AppReducerStateProps;
  infomation: CheckWithPrefixResponse;
}

function ExchangePage(props: ExchangePageProps) {
  const { SMPoint } = props.state.member.getinfo;
  const [udiamondList, setUdiamondList] = useState<GetUdiamondAllResponse[]>(
    []
  );
  const [showModal, setShowModal] = useState(false);
  const [selectUDiamond, setSelectUDiamond] =
    useState<GetUdiamondAllResponse>();

  useEffect(() => {
    get_udiamond_all().then((json) => {
      setUdiamondList(json);
    });
  }, []);

  return (
    <LayoutMaster
      content_setting={{
        title: "แลก uDiamond เป็นเครดิต",
        description:
          "uDiamond มีค่า สามารถนำไปแลกเครดิต เพื่อใช้ในการเดิมพันได้",
      }}
      information={props.infomation}
    >
      <div className="container children-top-margin-top-10">
        <h1 style={{ fontSize: 30 }}>
          <span>แลก uDiamond เป็นเครดิต</span>
        </h1>
        <div className="text-center margin-bottom-10">
          <div className="btn-group">
            <div className="card-ufa-category">
              คงเหลือ {(SMPoint ?? 0).format(2, 0)} uDiamond
            </div>
          </div>
        </div>
        {udiamondList.map((value, i) => (
          <button
            key={i}
            className="row center-row-content col-md-3 col-4 btn btn-choose-money"
            onClick={() => {
              setShowModal(!showModal);
              setSelectUDiamond(value);
            }}
          >
            <div style={{ fontSize: 12 }}>
              {value.AmountUdiamond?.format(0, 0)} uDiamond
            </div>
            <div className="font-bold" style={{ fontSize: 14 }}>
              <span>{value.AmountCredit?.format(0, 0)} บาท</span>
            </div>
          </button>
        ))}
      </div>
      <div className="container">
        <h2>
          <span>ขั้นตอนในการแลกเครดิต</span>
        </h2>
        <ul>
          <li>เลือก แพ็คเกจ ที่ท่านต้องการ</li>
          <li>กดปุ่ม แลกเครดิต</li>
          <li>เมื่อสำเร็จเครดิตจะเข้าไปอยู่ในกระเป้าเงินของท่าน</li>
          <li className="text-danger">
            ข้อกำหนดของบริษํท อาจจะเปลี่ยนแปลงตามนโยบายที่ทางบริษัทเป็นผู้กำหนด
          </li>
        </ul>
      </div>
      <UDiamondModal
        show={showModal}
        selectUDiamond={selectUDiamond}
        handleExchangeSuccuess={() => {
          setShowModal(!showModal);
        }}
        handleClose={() => {
          setShowModal(!showModal);
        }}
      ></UDiamondModal>
    </LayoutMaster>
  );
}

export const getServerSideProps: GetServerSideProps<any> = async (context) => {
  const { req } = context;
  console.log("COTEXT =>", req.headers.host);
  console.log("query =>", context.query);
  const infomation = CheckWithPrefix({ host: req.headers.host as string });

  return {
    props: {
      isLogin: context.req.cookies.access_token != undefined,
      infomation: infomation,
    },
  };
};

const mapStateToProps = (state: AppReducerStateProps) => {
  return {
    state: state,
  };
};

export default connect(mapStateToProps)(ExchangePage);
